import { handleActions } from 'redux-actions';
import {
  SET_ACTIVE_INTEGRATION,
  SET_CONNECTIONS_ORDER_BY,
  RESET_STATE,
} from './actions';

const initialState = {
  connectionsOrderBy: {
    orderDir: 'desc',
    keyName: 'updatedAt',
  },
  activeIntegration: 'mailchimp',
};

export const setConnectionsOrderBy = (state, { payload }) => {
  const { connectionsOrderBy } = payload;

  return {
    ...state,
    connectionsOrderBy,
  };
};

export const setActiveIntegration = (state, { payload }) => {
  const { activeIntegration } = payload;

  return {
    ...state,
    activeIntegration,
  };
};

export const resetState = () => {
  return initialState;
};

const mappedReducers = {
  [SET_CONNECTIONS_ORDER_BY]: setConnectionsOrderBy,
  [SET_ACTIVE_INTEGRATION]: setActiveIntegration,
  [RESET_STATE]: resetState,
};

const connectionsTableState = handleActions(mappedReducers, initialState);

export default connectionsTableState;
